// @see https://github.com/fregante/object-fit-images
import objectFitImages from"object-fit-images";import"../media";import"./index.scss";objectFitImages(".mediaElement");